export default async function GetInvestorInvestmentDetails() {
    let url = window.RealestateService+  `/api/Investor/GetInvestorInvestmentDetails?investorType=0`
    let head = {
         "content-type":"application/json",
        "accept":"*/*"
    }
    let response = await fetch(url, {
        method:"GET",
        headers:head,
    }).then(res=>res.json()).catch(res=>res)

    return response
}